import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['container', 'innerContainer', 'control', 'label'];
var controlStyles = {
  w: 5,
  h: 5,
  backgroundColor: 'white',
  borderWidth: '0.0625rem',
  borderStyle: 'solid',
  borderColor: 'blue.600',
  borderRadius: '50%',
  transition: 'all 150ms ease',
  cursor: 'pointer',
  position: 'relative',
  top: '1px',
  _checked: {
    borderWidth: '0.3125rem'
  },
  _hover: {
    cursor: 'pointer'
  },
  _focus: {
    boxShadow: "0 0 0.1875rem 0.125rem #00CAFF",
    outline: 'none'
  },
  _invalid: {
    borderColor: 'red.700',
    _focus: {
      boxShadow: '0 0 0.25rem 0.0625rem #D0011C'
    }
  },
  _disabled: {
    boxShadow: 'none',
    borderColor: 'grey.500',
    backgroundColor: 'white'
  }
};
var labelStyles = {
  color: 'currentColor',
  fontSize: 'inherit',
  fontFamily: 'inherit',
  fontWeight: 'inherit',
  letterSpacing: 'inherit',
  pl: 3,
  _hover: {
    cursor: 'pointer'
  },
  _disabled: {
    borderColor: 'grey.400',
    color: 'grey.800'
  }
};
var containerStyles = {
  mb: 0,
  color: 'black',
  fontWeight: 'normal',
  letterSpacing: 'tight',
  fontFamily: 'body',
  fontSize: 'md'
};
var innerContainerStyles = {
  display: 'inline-flex',
  alignItems: 'flex-start',
  cursor: 'pointer',
  _disabled: {
    cursor: 'auto'
  }
};
var baseStyle = () => ({
  container: containerStyles,
  label: labelStyles,
  control: controlStyles,
  innerContainer: innerContainerStyles
});
var sizes = {
  md: {
    control: {
      w: 5,
      h: 5
    },
    label: {
      fontSize: 'md'
    }
  },
  lg: {
    control: {
      w: 6,
      h: 6
    },
    label: {
      fontSize: 'lg'
    }
  },
  sm: {
    control: {
      width: 3,
      height: 3,
      _checked: {
        borderWidth: '0.20rem'
      }
    },
    label: {
      fontSize: 'sm'
    }
  }
};
var defaultProps = {
  size: 'md',
  colorScheme: 'blue'
};
export default asMultiStyleConfig({
  parts,
  baseStyle,
  sizes,
  defaultProps
});